import { FC } from 'react'
import { arrayMove } from '../../../../util/arrayMethods'
import { ChallengerBox } from '../ChallengerBox/ChallengerBox'

import Style from './Top3Users.module.scss'
interface Props {
    rank: LeaderBoard[] | []
}

export const Top3Users: FC<Props> = ({ rank }) => {
    return (
        <div className={Style.container}>
            {arrayMove(rank.slice(0, 3), 0, 1).map((re, index) => (
                <div
                    key={index}
                    style={{
                        paddingTop: index === 1 ? 0 : 66,
                        position: 'relative',
                        height: '340px',
                        width: '30%',
                    }}
                >
                    <ChallengerBox
                        key={re.rank}
                        tier={re.tier?.name}
                        highlighted={index === 1}
                        profileName={re.additional_user_info?.profileName}
                        score={re.score}
                        rank={re.rank}
                        seasonEnd
                    />
                </div>
            ))}
        </div>
    )
}
